// Modules
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
// Styles
import Styles from "./Styles/MobileSideBar.module.css";
// Images
import growthImage from "../../../../Assets/Icons/growth.png";
import magazinesImage from "../../../../Assets/Icons/magazines.png";
import networkingImage from "../../../../Assets/Icons/networking.png";
import onlineLearningImage from "../../../../Assets/Icons/online-learning.png";
import supportImage from "../../../../Assets/Icons/support.png";
import aboutusImage from "../../../../Assets/Icons/about-us.png";
import instagramLogo from "../../../../Assets/Icons/instagram-logo-black.png";
import eitaLogo from "../../../../Assets/Icons/eitaa-logo-black.png";
import gmailIcon from "../../../../Assets/Icons/gmail-logo-black.png";
import telegramImage from "../../../../Assets/Icons/telegram.png";
import facebookImage from "../../../../Assets/Icons/facebook.png";
import journalIcon from "../../../../Assets/Icons/journal-light.png";
import imageArticleIcon from "../../../../Assets/Icons/Image-article-light.png";
import quarterlyIcon from "../../../../Assets/Icons/quarterly-light.png";
import bookStoreIcon from "../../../../Assets/Icons/book-store-light.png";
import libraryIcon from "../../../../Assets/Icons/library-light.png";
import loginIcon from "../../../../Assets/Icons/login.png";
import registerIcon from "../../../../Assets/Icons/register.png";

const MobileSideBar = () => {
  return (
    <div className={Styles.container}>
      <div className={Styles.menu}>
        <div className={Styles.itemContainer}>
          <h3>مجله اینترنتی</h3>
          <img src={onlineLearningImage} alt="" />
          <div className={Styles.underMenue}>
            <Link to="/journal" className={Styles.container}>
              <h3>
                نشریه آنلاین <img src={journalIcon} alt="" />
              </h3>
            </Link>
            <Link to="/image-articles" className={Styles.container}>
              <h3>
                مقاله تصویری <img src={imageArticleIcon} alt="" />
              </h3>
            </Link>
            <Link to="/quarterly" className={Styles.container}>
              <h3>
                فصلنامه <img src={quarterlyIcon} alt="" />
              </h3>
            </Link>
          </div>
        </div>
        <div className={Styles.itemContainer}>
          <h3>نشر دیجیتال</h3>
          <img src={magazinesImage} alt="" />
          <div className={Styles.underMenue}>
            <Link to="/library" className={Styles.container}>
              <h3>
                فروشگاه کتاب <img src={bookStoreIcon} alt="" />
              </h3>
            </Link>
            <Link to="/library/my-books" className={Styles.container}>
              <h3>
                کتابخانه دیجیتال <img src={libraryIcon} alt="" />
              </h3>
            </Link>
          </div>
        </div>
        <div className={Styles.itemContainer}>
          <div className={Styles.text}>
            توسعه حرفه ای<h6>بزودی</h6>
          </div>
          <img src={growthImage} alt="" />
        </div>
        <div className={Styles.itemContainer}>
          <div className={Styles.text}>
            سامانه جامع شبکه سازی آموزشی<h6>بزودی</h6>
          </div>
          <img src={networkingImage} alt="" />
        </div>
        <div className={Styles.itemContainer}>
          <Link to="/about-us">
            <h3>درباره ما</h3>
          </Link>
          <img src={aboutusImage} alt="" />
        </div>
        <div className={Styles.itemContainer}>
          <Link to="/contact-us">
            <h3>ارتباط با ما</h3>
          </Link>
          <img src={supportImage} alt="" />
        </div>
        <div className={Styles.itemContainer}>
          <Link className={Styles.auth} to="/users/login">
            ورود
          </Link>
          <img src={loginIcon} alt="" />
        </div>
        <div className={Styles.itemContainer}>
          <Link className={Styles.auth} to="/users/register">
            ثبت نام
          </Link>
          <img src={registerIcon} alt="" />
        </div>
      </div>
      {/* footer */}
      <div className={Styles.footer}>
        <div className={Styles.news}>
          <h3>عضویت در خبرنامه</h3>
          <div className={Styles.membershipContainer}>
            <button>عضویت</button>
            <input placeholder="ایمیل خود را وارد کنید" type="email" />
          </div>
        </div>
        <h2 className={Styles.text}>
          شبکه‌های اجتماعی هُرمه سریع‌ترین روش دسترسی به مطالب مختلف است اگر
          می‌خواهید به‌روز باشید، شبکه‌های اجتماعی هُرمـه را دنبال کنید
        </h2>
        <div className={Styles.social}>
          <Link to="">
            <img src={telegramImage} alt="" />
          </Link>
          <a
            href="https://www.instagram.com/horme.education/?utm_source=ig_web_button_share_sheet&igshid=MmVlMjlkMTBhMg=="
            target="_blank"
            rel="noreferrer"
          >
            <img src={instagramLogo} alt="" />
          </a>
          <a href="https://eitaa.com/Horme_ir" target="_blank" rel="noreferrer">
            <img src={eitaLogo} alt="" />
          </a>
          <a
            href="mailto:horme.operator1@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            <img src={gmailIcon} alt="" />
          </a>
          <Link to="">
            <img src={facebookImage} alt="" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MobileSideBar;
